import {
  Component,
  OnInit,
  Input,
  Optional,
  Inject,
  ViewChild,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ChartDataSets, ChartOptions, ChartType } from "chart.js";
import { Label, BaseChartDirective } from "ng2-charts";

@Component({
  selector: "app-chart-dialog",
  templateUrl: "./chart-dialog.component.html",
  styleUrls: ["./chart-dialog.component.scss"],
})
export class ChartDialogComponent implements OnInit {
  @ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective;
  chartKpi: any = [];
  chartData: ChartDataSets[] = [
    {
      data: [],
      borderColor: "#57aeef",
      backgroundColor: "#ffffff",
      hoverBackgroundColor: "#ffffff",
      borderWidth: 2,
      pointBorderColor: "#57aeef",
      pointStyle: "circle",
      pointRadius: 5,
      pointBackgroundColor: "#57aeef",
    },
  ];
  chartHeight: any;
  chartWidth: any;
  chartLabels: Label[] = [];
  chartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltips: {
      enabled: true,
    },
    scales: {
      xAxes: [
        {
          display: true,
          gridLines: {
            display: true,
          },
          scaleLabel: {
            display: true,
          },
          ticks: {
            beginAtZero: false,
            display: true,
          },
        },
      ],
      yAxes: [
        {
          display: true,
          ticks: {
            beginAtZero: false,
            autoSkip: false,
          },
        },
      ],
    },
    elements: {
      line: {
        fill: false,
        tension: 0.000001,
      },
      point: {
        radius: 0,
      },
    },
  };
  chartPlugins: any = [];
  chartLegend: boolean = false;
  chartType: ChartType = "line";
  chartName: string;

  constructor(
    private dialogRef: MatDialogRef<ChartDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    let maxActualVal = 0;
    let minActualVal = 0;
    this.chartKpi = this.data["kpi"];
    this.chartName = this.chartKpi[0].kpiName;
    this.chartLabels.length = 0;
    this.chartKpi.forEach((kpi) => {
      const label = kpi.monthVal + "/" + kpi.yearVal;
      this.chartLabels.push(label);
      this.chartData[0].data.push(kpi.actualVal);
      if (maxActualVal < kpi.actualVal) {
        maxActualVal = kpi.actualVal;
      }
      if (minActualVal > kpi.actualVal) {
        minActualVal = kpi.actualVal;
      }
    });
    this.chartOptions.scales.xAxes[0].ticks.max = 14;
    let unit = this.chartKpi[0].unit;
    if (this.chartKpi[0].kpiCode == "014") {
      this.chartOptions.scales.yAxes[0].ticks.stepSize = 1;
      this.chartOptions.scales.yAxes[0].ticks.callback = function (value) {
        return value + "" + unit;
      };
    } else {
      if (Math.round(maxActualVal) > 2) {
        this.chartOptions.scales.yAxes[0].ticks.stepSize = 5;
        if (Math.round(maxActualVal) + 5 >= 90) {
          this.chartOptions.scales.yAxes[0].ticks.max = 100;
        }
      } else {
        this.chartOptions.scales.yAxes[0].ticks.stepSize = 1;
      }
      this.chartOptions.scales.yAxes[0].ticks.callback = function (value) {
        return value + "" + unit;
      };
    }
    this.chart.update();
  }

  close() {
    this.dialogRef.close();
  }
}
